import { type TablePreferencesConfig } from 'src/common/ui/TablePreferences';
import type { TranslateFn } from 'src/i18n/shim/useTranslation';

/**
 * Configs for the string detail page's two tables. Neither offers a page size —
 * both render every row unpaged, so a size control would page nothing.
 */

/**
 * Actions is the row's entry point, so `alwaysVisible` and pinned last: the CX ID
 * cell also links, but a user who hid that column would be stranded.
 */
const VARIANT_ACTIONS_COLUMN_ID = 'actions';

export const localesTablePreferences = (
  t: TranslateFn,
): TablePreferencesConfig => ({
  storageKey: 'LangHub-localesTablePreferences',
  columnOptions: [
    { id: 'locale', label: t('string-column-locale') },
    { id: 'status', label: t('string-column-status') },
    { id: 'translatedText', label: t('string-column-translation') },
  ],
});

export const variantsTablePreferences = (
  t: TranslateFn,
): TablePreferencesConfig => ({
  storageKey: 'LangHub-variantsTablePreferences',
  columnOptions: [
    { id: 'cxId', label: t('string-column-cx-id') },
    { id: 'sourceText', label: t('string-column-variant-source-text') },
    {
      id: VARIANT_ACTIONS_COLUMN_ID,
      label: t('string-column-actions'),
      alwaysVisible: true,
    },
  ],
  pinnedLastColumnId: VARIANT_ACTIONS_COLUMN_ID,
});
